module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/headerhome/headerhome.component.scss
// module id = ./src/app/headerhome/headerhome.component.scss
// module chunks = main